<template>
    <div class="active-button-contain">
        <img
            class="coupon-img"
            ref="couponImgRef"
            :src="imgUrl"
            alt="优惠券"
            @click="getCoupon"
        >
    </div>
</template>

<script>
export default {
    name: "ActiveButton",
    props: {
        data: {
            type: Object
        }
    },
    data() {
        const { thumbnail, couponsId } = this.data.tempData.specialEntry;
        return {
            couponsId, // 传入的优惠券ucode
            imgUrl: thumbnail || require("../asset/images/default-active.jpg"), // 传入的图片链接
        };
    },
    methods: {
        // getCouponInfo() {
        //     this.$apis.coupon
        //         .getCouponInfo({
        //             ucode: this.couponsId
        //         })
        //         .then(res => {
        //             console.log("-----获取优惠券参数", res);
        //         });
        // },
        getCoupon() {
            if(!localStorage.getItem('token')){ // 未登录 跳转登录页
                if(this.$isapp){
                    this.$WDJSBridge.jumpNAPage(JSON.stringify({ pageName: "login" }));
                } else {
                    this.$router.push({
                    path: "/login",
                    query: {
                        name: window.location.pathname
                    }
                })
                }
                return 
            }
            // 登录后   领取逻辑
            this.$apis.standard
                .getCoupons({
                    ucode: this.couponsId
                })
                .then(res => {
                    if (res.success) {
                        this.$toast('领取成功，快去使用吧')
                    }
                });
        }
    }
};
</script>

<style lang="less" scoped>
.active-button-contain {
    font-size: 0;
    .coupon-img {
        width: 100%;
        height: 100%;
    }
}
</style>
